/*
 * popup-vip.js — convite para o Grupo VIP do WhatsApp.
 *
 * Grava o contato na base do painel (com data, IP e UTM como prova de
 * consentimento) e devolve na hora o link do grupo. As configurações vêm do
 * editor de tema, pelos `data-` da section — nada de texto ou prazo aqui.
 *
 * ⚠️ O LINK VIRA BOTÃO, NÃO ABRE SOZINHO. `window.open` só é permitido DURANTE
 * um gesto da pessoa, e este código roda depois da resposta do servidor, fora
 * dessa janela. No Chrome do Windows passa; no Safari do iPhone, no navegador
 * de dentro do Instagram e com extensão de bloqueio, não — e é justamente por
 * aí que vem boa parte do tráfego da loja. Ali a pessoa entraria na lista e
 * nunca chegaria ao WhatsApp, que foi o que a fez preencher. Clique é gesto, e
 * gesto nenhum navegador barra. Medido em 11/08/2026.
 *
 * E é sempre o link que VEIO NA RESPOSTA, nunca um endereço fixo do WhatsApp:
 * é ele que escolhe o grupo com vaga, conta o clique e registra a origem.
 */
(function () {
  'use strict';

  // O editor pode reinserir a tag <script> ao recriar a section. Sem esta trava,
  // os ouvintes de `shopify:section:*` seriam registrados de novo a cada mexida.
  if (window.popupVipCarregado) return;
  window.popupVipCarregado = true;

  var CHAVE = 'cbv_vip_visto';

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.pronto === '1') return;
    raiz.dataset.pronto = '1';

    var api = raiz.dataset.api;
    var gatilho = raiz.dataset.gatilho || 'tempo';
    var segundos = Number(raiz.dataset.segundos) || 8;
    var dias = Number(raiz.dataset.dias) || 30;
    var ativo = raiz.dataset.ativo === '1';
    var editor = raiz.dataset.editor === '1';

    var caixa = raiz.querySelector('.popup-vip__caixa');
    var form = raiz.querySelector('.popup-vip__form');
    var nome = raiz.querySelector('.popup-vip__nome');
    var email = raiz.querySelector('.popup-vip__email');
    var botao = raiz.querySelector('.popup-vip__enviar');
    var recado = raiz.querySelector('.popup-vip__recado');
    var sucessoTexto = raiz.querySelector('.popup-vip__sucesso-texto');
    var botaoGrupo = raiz.querySelector('.popup-vip__grupo');
    if (!form || !email || !botao) return;

    /* Quem já viu não vê de novo. Sem isto o popup reaparece a cada página e
       vira motivo para a pessoa sair da loja. Navegação anônima bloqueia o
       storage — nesse caso o popup aparece uma vez por sessão e pronto. */
    function jaViu() {
      try {
        var ate = localStorage.getItem(CHAVE);
        return ate && Number(ate) > Date.now();
      } catch (e) {
        return false;
      }
    }

    function marcarVisto(quantosDias) {
      if (editor) return; // testar no editor não pode calar o popup na loja
      try {
        localStorage.setItem(CHAVE, String(Date.now() + quantosDias * 864e5));
      } catch (e) {}
    }

    function abrir() {
      raiz.classList.add('is-open');
      /* Nada de `body.overflow-hidden` aqui, apesar de ser o padrão do tema para
         menu e drawer: aquela classe usa `position: fixed`, que joga a página de
         volta ao topo. O menu abre por clique, então o tranco não aparece; este
         popup abre sozinho no meio da rolagem e faria a pessoa perder o lugar.

         O teclado do celular tapa metade da tela e esconderia o texto que
         convence, então o foco automático fica só onde há teclado físico. */
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        setTimeout(function () {
          (nome || email).focus();
        }, 50);
      }
    }

    function fechar() {
      raiz.classList.remove('is-open');
      marcarVisto(dias);
    }

    // O editor precisa abrir e fechar a caixa ao selecionar a section na lista.
    raiz.abrirPopup = abrir;
    raiz.fecharPopup = function () {
      raiz.classList.remove('is-open');
    };

    raiz.querySelector('.popup-vip__fechar').addEventListener('click', fechar);
    raiz.addEventListener('click', function (e) {
      if (!caixa.contains(e.target)) fechar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && raiz.classList.contains('is-open')) fechar();
    });

    /* De onde a visitante veio. O painel guarda junto com a inscrição — é o que
       depois responde "esta lista veio de onde?". Sem UTM na URL, fica o padrão
       combinado com o painel. */
    function origem() {
      try {
        var p = new URLSearchParams(location.search);
        var s = p.get('utm_source');
        var m = p.get('utm_medium');
        if (s) {
          return (
            'utm_source=' +
            encodeURIComponent(s) +
            (m ? '&utm_medium=' + encodeURIComponent(m) : '')
          );
        }
      } catch (e) {}
      return 'utm_source=site&utm_medium=popup';
    }

    function erro(texto) {
      recado.className = 'popup-vip__recado -erro';
      recado.textContent = texto;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var valor = (email.value || '').trim();
      if (valor.indexOf('@') < 1 || valor.indexOf('.') < 0) {
        erro('Confira o email.');
        return;
      }

      var textoOriginal = botao.textContent;
      botao.disabled = true;
      botao.textContent = 'Entrando…';
      recado.className = 'popup-vip__recado';
      recado.textContent = '';

      fetch(api + '?' + origem(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: valor,
          nome: (nome.value || '').trim(),
          origem: 'popup',
        }),
      })
        // Um 500 devolve HTML, e aí o `json()` estoura com uma mensagem técnica
        // em inglês que não pode chegar ao cliente. Vira nulo e cai no genérico.
        .then(function (r) {
          return r.json().catch(function () {
            return null;
          });
        })
        .then(function (d) {
          if (!d || !d.ok) throw new Error((d && d.error) || '');

          marcarVisto(365); // quem entrou não precisa ser convidado de novo
          sucessoTexto.textContent = d.jaInscrito
            ? 'Você já estava na lista!'
            : 'Pronto, você está na lista!';

          if (d.link) {
            botaoGrupo.href = d.link;
            raiz.classList.add('is-inscrito');
            botaoGrupo.focus();
          } else {
            // Inscreveu mas não veio link: pelo menos não fingir que deu tudo
            // certo com um botão que não leva a lugar nenhum.
            raiz.classList.add('is-inscrito');
            botaoGrupo.remove();
          }
        })
        .catch(function (err) {
          botao.disabled = false;
          botao.textContent = textoOriginal;
          /* O painel já devolve o erro em português, e o dele explica melhor —
             "muitas tentativas, espere alguns minutos" diz o que fazer. O texto
             da casa entra só quando não veio nada, que é quando a rede caiu. */
          erro(err.message || 'Não consegui agora. Tente de novo em instantes.');
        });
    });

    // ---- Quando aparecer ----

    var abriu = false;
    function abrirUmaVez() {
      if (abriu) return;
      abriu = true;
      abrir();
    }

    function porTempo() {
      setTimeout(abrirUmaVez, segundos * 1000);
    }

    function porRolagem() {
      function conferir() {
        var altura = document.documentElement.scrollHeight - window.innerHeight;
        if (altura <= 0 || window.scrollY / altura >= 0.5) {
          window.removeEventListener('scroll', conferir);
          abrirUmaVez();
        }
      }
      window.addEventListener('scroll', conferir, { passive: true });
    }

    function porSaida() {
      /* Não existe "sair da página" no celular: não há ponteiro para cruzar a
         borda de cima. Sem a volta para o tempo, o popup simplesmente nunca
         apareceria para a maior parte do tráfego da loja. */
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        porTempo();
        return;
      }
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) abrirUmaVez();
      });
    }

    // No editor a caixa abre na hora: quem acabou de ligar a opção precisa ver
    // o que ligou, e esperar oito segundos passa por "não funcionou".
    if (editor) {
      if (ativo) abrir();
      return;
    }

    if (!ativo || jaViu()) return;

    /* Daqui para baixo só chega quem VAI ver o convite, e é só para essa pessoa
       que a foto começa a baixar. Ela é `lazy` no HTML para não pesar na página
       de quem já se inscreveu ou já fechou — mas deixada só no lazy, o download
       começaria no instante em que a caixa abre: a coluna apareceria vazia e o
       tecido entraria depois, na cara de quem está lendo. Trocar para `eager`
       aqui dispara a busca agora e dá os segundos do gatilho de vantagem. */
    var foto = raiz.querySelector('.popup-vip__imagem');
    if (foto) foto.loading = 'eager';

    if (gatilho === 'rolagem') porRolagem();
    else if (gatilho === 'saida') porSaida();
    else porTempo();
  }

  function daSection(alvo) {
    return alvo && alvo.querySelector ? alvo.querySelector('.popup-vip') : null;
  }

  iniciar(document.querySelector('.popup-vip'));

  // O editor recria o HTML da section a cada mudança de configuração.
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(daSection(e.target));
  });
  document.addEventListener('shopify:section:select', function (e) {
    var raiz = daSection(e.target);
    if (raiz && raiz.abrirPopup) raiz.abrirPopup();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var raiz = daSection(e.target);
    if (raiz && raiz.fecharPopup) raiz.fecharPopup();
  });
})();
